import React, { Component } from "react";
import { push } from "../Services/Analytics"
import "./ShareIcons.scss"

class ShareIcons extends Component {
  constructor() {
    super();
    this.state = {}
    this.shareBTN = this.shareBTN.bind(this);
  }
  shareBTN(action) {
    var shareText = "השתתפו בחידון קצר ותוכלו לזכות בזוג משקפי מציאות מדומה דרכם תוכלו לראות גם את ההמראה של החללית הישראלים הראשונה";
    var url = "https://z.ynet.co.il/mshort/commerce/2018/spaceship/";
    switch (action) {
      default:
      case "facebook":
        push("Share_Facebook", url);
        window.open("http://www.facebook.com/share.php?u=" + encodeURIComponent(url) + "&redirect_uri=" + encodeURIComponent(url), "_blank");
        break;
      case "twitter":
        push("Share_Twitter", url);
        window.open("https://twitter.com/intent/tweet?text=" + encodeURIComponent(window.document.title) + "&url=" + encodeURIComponent(url), "_blank");
        break;
      case "whatsapp":
        push("Share_WhatsApp", url);
        window.open("whatsapp://send?text=" + encodeURIComponent(shareText + " >> " + url), "_parent");
        break;
      case "negishut":
        push("Accessibility", "Open_Accessibility_Clicked");
        var elem = window.document.getElementById('INDmenu-btn');
        var event = new Event('click');
        elem.dispatchEvent(event);
        break;
      case "sharer":
        this.setState({
          isShareActive: !this.state.isShareActive
        })
        break;
    }
  }
  render() {
    return (
      <div className="sharemobile">
        <div className="links">
          <div className="share">
            <div onClick={() => { this.shareBTN("whatsapp") }} className="whatsapp"></div>
            <div onClick={() => { this.shareBTN("facebook") }} className="facebook"></div>
            <div onClick={() => { this.shareBTN("negishut") }} className="negishut"></div>
          </div>
        </div>
      </div>
    );
  }
}

export default ShareIcons;



// WEBPACK FOOTER //
// ./src/Components/Header/ShareIcons.js